module.exports = __webpack_public_path__ + "ac0f8f56aff7d1e78f0848cc8620c301.svg";